export const PRIMARY_EVENT_PAGE_PROP = "primaryEvent";
export const EVENT_PROMOTION_BLOCK_PROP = "eventPromotion";

export type EventPromotionSource = "primary" | "override" | "none";

export type PrimaryEventConfig = {
  eventExternalId?: string | null;
};

export type EventPromotionConfig = {
  source: EventPromotionSource;
  eventExternalId?: string | null;
  showDateTime: boolean;
  ctaLabel?: string;
};

export type EventSummaryUnavailableReason =
  | "deleted"
  | "draft"
  | "building"
  | "preview"
  | "missing"
  | "unavailable";

export type ContentHubEventSummaryRaw = {
  external_id: string;
  slug?: string | null;
  title?: string | null;
  name?: string | null;
  description?: string | null;
  image?: string | null;
  image_url?: string | null;
  logo?: string | null;
  logo_url?: string | null;
  time_start?: string | null;
  time_end?: string | null;
  timezone?: string | null;
  registration_url?: string | null;
  availability?: "available" | EventSummaryUnavailableReason;
  deleted?: boolean;
};

export type AvailableContentHubEventSummary = {
  id: string;
  status: "available";
  slug?: string | null;
  title: string;
  description: string | null;
  image: string | null;
  logo: string | null;
  timeStart: string | null;
  timeEnd: string | null;
  timezone: string | null;
  registrationUrl: string | null;
};

export type UnavailableContentHubEventSummary = {
  id: string;
  status: "unavailable";
  reason: EventSummaryUnavailableReason;
  title?: string;
};

export type ContentHubEventSummary =
  | AvailableContentHubEventSummary
  | UnavailableContentHubEventSummary;

export type ContentHubEventSummaryResponse = {
  data: ContentHubEventSummaryRaw[];
  unavailable_event_ids?: string[];
};
